import React, { Component } from 'react';
import IconButtonGroup from '../../Misc/IconButtonGroup';
import '../../../content/css/IconButtonGroup.css';

export default class DocumentItemMenu extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            options: [
                { name: 'analyze', glyph: 'align-center', text: 'Review' },
                { name: 'delete', glyph: 'remove-circle', text: 'Delete' }
            ]
        };
    }

    handleButtonClick = (name) => {
        if (name == 'analyze') this.props.onReview();
        if (name == 'delete') this.props.onDelete();
    }

    getClassName = () => {
        let name = 'document-item-menu';
        if (this.props.show) name += ' showing';
        if (!this.props.show) name += ' hiding';

        return name;
    }

    render() {
        return (
            <div className={this.getClassName()}>
                <IconButtonGroup buttons={this.state.options} onClick={this.handleButtonClick} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Home/DocumentList/DocumentItemMenu.js